module.exports = __webpack_public_path__ + "media/assets/icons/checkboxes/check-square-darkgray-1f468cfd06de85d138f28ae7fa7afbf9.svg";